/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ versionTitle: NonNullable<unknown> }} Learn_Pagetitle1Inputs */

const zh_learn_pagetitle1 = /** @type {(inputs: Learn_Pagetitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.versionTitle} | StudyOS Learn`)
};

const en_learn_pagetitle1 = /** @type {(inputs: Learn_Pagetitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.versionTitle} | StudyOS Learn`)
};

const es_learn_pagetitle1 = /** @type {(inputs: Learn_Pagetitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.versionTitle} | StudyOS Learn`)
};

/**
* | output |
* | --- |
* | "{versionTitle} \| StudyOS Learn" |
*
* @param {Learn_Pagetitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_pagetitle1 = /** @type {((inputs: Learn_Pagetitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Pagetitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_pagetitle1(inputs)
	if (locale === "en") return en_learn_pagetitle1(inputs)
	return es_learn_pagetitle1(inputs)
});
export { learn_pagetitle1 as "learn_pageTitle" }